import { render, staticRenderFns } from "./OtpModal.vue?vue&type=template&id=31154084&scoped=true"
import script from "./OtpModal.vue?vue&type=script&lang=js"
export * from "./OtpModal.vue?vue&type=script&lang=js"
import style0 from "./OtpModal.vue?vue&type=style&index=0&id=31154084&prod&lang=scss"
import style1 from "./OtpModal.vue?vue&type=style&index=1&id=31154084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31154084",
  null
  
)

export default component.exports